import "./TrendForecast.scss";
import { Helmet } from "react-helmet-async";

export default function TrendForecast() {

  return (
      <>
      {/* 🔴 BLOCK SEARCH ENGINE INDEXING */}
      <Helmet>
        <title>Admin Login | Brands On Move</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <link rel="canonical" href="https://brandsonmove.com/trueasuretrove/trend_forecast" />
      </Helmet>
    <div className="trend_forecast_container">
        <h1>Coming Soon..</h1>
    </div>
    </>
  );
}
